export default "__VITE_ASSET__Dz5iGrPu__"